import { render, staticRenderFns } from "./Nfresh.vue?vue&type=template&id=42f5eff6&scoped=true&"
import script from "./Nfresh.vue?vue&type=script&lang=ts&"
export * from "./Nfresh.vue?vue&type=script&lang=ts&"
import style0 from "./Nfresh.vue?vue&type=style&index=0&id=42f5eff6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f5eff6",
  null
  
)

export default component.exports